export default __webpack_public_path__ + "static/media/boxSlipperMb2.a9d2b94a.png";